import { render, staticRenderFns } from "./storeOrderRecord.vue?vue&type=template&id=16b65e78&scoped=true"
import script from "./storeOrderRecord.vue?vue&type=script&lang=js"
export * from "./storeOrderRecord.vue?vue&type=script&lang=js"
import style0 from "./storeOrderRecord.vue?vue&type=style&index=0&id=16b65e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b65e78",
  null
  
)

export default component.exports